import classnames from "classnames";
import Markdown from "markdown-to-jsx";
import React, { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import type { MarkdownExpandableTextProps } from "src/components/MarkdownExpandableText/MarkdownExpandableTextProps";
import { getTranslatedValue } from "src/utils";

const SEE_MORE = "aic_nest_see_more_button";
const SEE_LESS = "aic_nest_see_less_button";
const COLLAPSE_SIZE = 200;
const SPACE = " ";

const MarkdownExpandableText: FC<MarkdownExpandableTextProps<any>> = ({
  content,
  valueStyle,
}) => {
  const { t } = useTranslation();
  const text = content.details?.valueOf() ?? "-";

  const [seeMore, setSeeMore] = useState(true);
  const enableCollapse = text.length > COLLAPSE_SIZE;

  const nearestSpace = text
    .substring(0, COLLAPSE_SIZE)
    .lastIndexOf(SPACE, COLLAPSE_SIZE);
  const croppedText = text.substring(
    0,
    nearestSpace < 0 ? COLLAPSE_SIZE : nearestSpace
  );

  const seeMoreSeeLessLink = (
    <a onClick={() => setSeeMore(!seeMore)} role="presentation">
      {seeMore
        ? getTranslatedValue(SEE_MORE, t)
        : getTranslatedValue(SEE_LESS, t)}
    </a>
  );

  return enableCollapse ? (
    <span className={classnames(valueStyle)}>
      <Markdown>{seeMore ? croppedText : text}</Markdown> &nbsp;
      {seeMoreSeeLessLink}
    </span>
  ) : (
    <span className={classnames(valueStyle)}>
      <Markdown>{text}</Markdown>
    </span>
  );
};

export default MarkdownExpandableText;
